import React, { useState, useEffect } from 'react';
import {Container, Paper, Typography, Button, Stack, useMediaQuery} from '@mui/material';
import MyChatWindow from './MyChatWindow';
import MyChatFullscreen from './MyChatFullscreen';
import ReplayIcon from "@mui/icons-material/Replay";
import ReactDOMServer from 'react-dom/server';
import Header from "./Header";
import FeedbackModal from "./FeedbackModal";
import {useTheme} from "@mui/material/styles";

export default function App() {
  const [mode, setMode] = useState(null);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const openWindowMode = () => setMode('window');
  const openFullscreenMode = () => setMode('fullscreen');
  const closeChat = () => setMode(null);
  const [refreshKey, setRefreshKey] = useState(Date.now());
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const defaultSubtitle =
      "O ChatBOT ABES pode cometer alguns erros. Disponível 24h por dia, todos os dias. Nos envie seu feedback!";
  let subtitle = isMobile ? ' ' : defaultSubtitle

  const onRefresh = () => {
    // Remove the session id.
    localStorage.removeItem('n8n-chat/sessionId');

    // Clear the messages (if needed)
    const messagesList = document.querySelector('.chat-messages-list');
    if (messagesList) {
      messagesList.innerHTML = '';
    }

    // Update the refresh key so that chat components reinitialize.
    setRefreshKey(Date.now());
  };

  useEffect(() => {
    // Function to add the logo to every chat header
    const addLogoToChatHeading = () => {
      document.querySelectorAll('.chat-heading').forEach((heading) => {
        if (!heading.querySelector('.chat-logo')) {
          const logo = document.createElement('img');
          logo.src = 'https://abes.com.br/wp-content/uploads/2021/11/logo_abes_tagline_horizontal_verde-amarelo.png';
          logo.alt = 'Logo';
          logo.className = 'chat-logo';
          logo.style.width = '100px';
          logo.style.height = '50px';
          logo.style.marginRight = '8px';
          heading.prepend(logo);
        }
      });
    };

    // Function to wrap each bot message in a container (if not already wrapped)
    // and add the logo on the left.
    const addBotMessageLogo = () => {
      document.querySelectorAll('.chat-message-from-bot').forEach((message) => {
        // If the bot message is not already wrapped in our custom container,
        // wrap it in a <div class="teste">.
        if (!message.parentElement.classList.contains('teste')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'teste';
          wrapper.style.display = 'flex';
          wrapper.style.alignItems = 'flex-end'; // Align children at the bottom

          // Create the logo image for the bot message.
          const logo = document.createElement('img');
          logo.src = 'https://abes.com.br/wp-content/uploads/2020/09/cropped-favicon-abes-new-32x32.png';
          logo.alt = 'Bot Logo';
          logo.className = 'bot-message-logo';
          logo.style.width = '30px';
          logo.style.height = '30px';
          logo.style.marginRight = '8px';

          // Insert the wrapper before the current message,
          // then move the logo and the message into it.
          message.parentNode.insertBefore(wrapper, message);
          wrapper.appendChild(logo);
          wrapper.appendChild(message);
        }
      });
    };

    const addReloadButtonToChatWindow = () => {
      const chatWindow = document.querySelector('.chat-window');
      if (chatWindow && !chatWindow.querySelector('.reload-button')) {
        // Ensure the chat window is relatively positioned
        chatWindow.style.position = 'relative';

        const button = document.createElement('button');
        button.type = 'button'; // Prevent form submission behavior
        button.className = 'reload-button';
        button.style.position = 'absolute';
        button.style.top = '20px';
        button.style.right = '20px'; // adjust as needed
        button.style.backgroundColor = 'rgba(0, 0, 0, 0)'; // Transparent background
        button.style.color = 'darkgray'; // Icon color
        button.style.border = 'none';
        button.style.marginRight = '10px'; // adjust if needed
        button.style.boxShadow = '0px 0px 5px rgba(0,0,0,0.15)';
        button.style.borderRadius = '10%';
        button.style.padding = '8px 15px 8px 15px';
        button.style.transition = 'background-color 0.2s ease';

        // Render the ReplayIcon to a string using Material UI's icon
        const iconMarkup = ReactDOMServer.renderToString(
            <div>
              <ReplayIcon style={{fill: 'darkgray', width: 24, height: 24}}/>
            </div>
        );
        button.innerHTML = iconMarkup;

        button.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          // Add a temporary background color to animate the click
          button.style.backgroundColor = 'lightgray';
          setTimeout(() => {
            button.style.backgroundColor = 'rgba(0, 0, 0, 0)';
          }, 200);
          onRefresh();
        });

        chatWindow.appendChild(button);
      }
    };

    // Try to add all elements immediately (if present in the DOM).
    addLogoToChatHeading();
    addBotMessageLogo();
    addReloadButtonToChatWindow();

    // Create a global MutationObserver to watch for new elements in the document.
    const observer = new MutationObserver(() => {
      addLogoToChatHeading();
      addBotMessageLogo();
      addReloadButtonToChatWindow();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup the observer on unmount.
    return () => observer.disconnect();
  }, []);

  return (
      <div>
        <Header />
        <Container maxWidth="sm" sx={{ mt: 4 }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
              ABES ChatBOT
            </Typography>
            <Typography variant="subtitle1" marginBottom="30px">
              Seja bem vindo à página de <strong>demonstração e testes</strong> do ChatBOT da ABES.
            </Typography>
            <Typography variant="body1" marginBottom="20px">
              Você foi convocado para verificar a eficácia do projeto em desenvolvimento, com <strong>intuito de
              identificar possíveis melhorias</strong> e nos informar, para que seja possível implementar melhorias e
                correções.
            </Typography>
            <Typography variant="body1" marginBottom="20px">
              Atualmente o ChatBOT é especialista no <strong>Estatuto Social da ABES e no Código de Ética da ABES</strong>. Informações e conhecimentos fora desse escopo não serão respondidas corretamente.
            </Typography>
            <Typography variant="body1" marginBottom="20px">
              Por favor, realize seus testes e <strong>preencha o formulário informando os resultados encontrados</strong>.
            </Typography>
            <Typography variant="body1" gutterBottom>
              Para testar o <strong>modo Janela</strong>, clique no canto inferior direito.
            </Typography>
            <Typography variant="body1" gutterBottom>
              Para acessar o <strong>modo Tela Cheia</strong> ou o <strong>Formulário de Feedback</strong>, clique nos botões abaixo:
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Button variant="contained" onClick={openFullscreenMode} color="primary">
                Tela Cheia
              </Button>
              <Button variant="contained" onClick={() => setFeedbackOpen(true)} color="primary">
                Feedback
              </Button>
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              OBS: Apenas um modo por vez estará visível. Ao clicar em outro modo, você verá o respectivo tipo de chat.
            </Typography>
          </Paper>
        </Container>

        <MyChatWindow key={refreshKey} onRefresh={onRefresh} />
        {mode === 'fullscreen' && <MyChatFullscreen
            onClose={closeChat}
            onRefresh={onRefresh}
            onFeedback={() => setFeedbackOpen(true)}
            key={refreshKey}
            subtitle={subtitle}/>}
        <FeedbackModal open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
      </div>
  );
}
